import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import gsap from 'gsap';
import './LegalShared.css';

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const tl = gsap.timeline();
    tl.fromTo('.legal-header-main', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' })
      .fromTo('.legal-brief-box', { x: -30, opacity: 0 }, { x: 0, opacity: 1, duration: 0.8, ease: 'power2.out' }, "-=0.4")
      .fromTo('.legal-section-card', { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, stagger: 0.15, ease: 'power2.out' }, "-=0.4");
  }, []);

  return (
    <div className="legal-page-shared">
      <div className="legal-container">
        <div className="legal-top-nav">
          <a href="/" className="back-link-gold">
            <ArrowLeft size={16} /> BACK TO HOME
          </a>
        </div>

        <header className="legal-header-main">
          <h1 className="legal-title-gold">Terms of Use</h1>
          <p className="legal-subtitle-white">The architecture of our arrangement</p>
        </header>

        <div className="legal-brief-box">
          <span className="brief-label">THE FOUNDATION</span>
          <p className="brief-text-gold">
            "Entering the Maison Escentrum is an agreement to appreciate artisanal excellence and respect the heritage of fine perfumery. These terms ensure a harmonious experience for all our guests."
          </p>
        </div>

        <div className="legal-content-grid">
          <section className="legal-section-card">
            <span className="section-tag">01. ELIGIBILITY</span>
            <h2 className="section-heading-gold">Access to the Maison</h2>
            <p className="section-text-white">
              By using this site, you represent that you are of legal age to appreciate fine art and fragrances in your jurisdiction. Our services are designed for individuals who seek the pinnacle of olfactory luxury.
            </p>
          </section>

          <section className="legal-section-card">
            <span className="section-tag">02. INTELLECTUAL PROPERTY</span>
            <h2 className="section-heading-gold">Copyright & Heritage</h2>
            <p className="section-text-white">
              All content, including our unique bottle designs, branding, and descriptive narratives, are the intellectual property of Escentrum. Any unauthorized duplication is an offense against our artisanal heritage.
            </p>
          </section>

          <section className="legal-section-card">
            <span className="section-tag">03. COMMERCE</span>
            <h2 className="section-heading-gold">Purchase & Transactions</h2>
            <p className="section-text-white">
              Each purchase is a binding agreement. We ensure that every product shipped meets our exacting standards of quality. In the rare event of a concern, our concierge is available to rectify it with speed and grace.
            </p>
          </section>

          <section className="legal-section-card">
            <span className="section-tag">04. LIMITATIONS</span>
            <h2 className="section-heading-gold">Liability & Conduct</h2>
            <p className="section-text-white">
              Escentrum provides an immersive luxury experience. While we strive for perfection, we are not liable for incidental events beyond our control. Users are expected to conduct themselves with the dignity befitting our Maison.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
